<section class="hero">
  <div class="hero__mesh"></div>
  <div class="hero__glow hero__glow--left"></div>
  <div class="hero__glow hero__glow--right"></div>

  <div class="auth-shell">
    <aside class="hero__panel">
      <div class="hero__panel-orb hero__panel-orb--large"></div>
      <div class="hero__panel-orb hero__panel-orb--small"></div>

      <div class="hero__panel-header">
        <span class="hero__panel-kicker">{{ 'login.kicker' | translate }}</span>
        <h2>{{ 'login.title' | translate }}</h2>
        <p>{{ 'login.subtitle' | translate }}</p>
      </div>

      <form class="login-form" [formGroup]="form" (ngSubmit)="submit()">
        <label class="login-form__field">
          <span>{{ 'login.usernameLabel' | translate }}</span>
          <div class="login-form__input-wrap">
            <span class="login-form__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" focusable="false">
                <path
                  d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4Zm0 2c-3.33 0-6.5 1.67-8 4.5A1 1 0 0 0 4.9 20h14.2a1 1 0 0 0 .9-1.5C18.5 15.67 15.33 14 12 14Z" />
              </svg>
            </span>
            <input type="text" formControlName="username" [placeholder]="'login.usernamePlaceholder' | translate" />
          </div>
          @if (hasError('username')) {
            <small class="login-form__error">{{ 'login.usernameRequired' | translate }}</small>
          }
        </label>

        <label class="login-form__field">
          <span>{{ 'login.passwordLabel' | translate }}</span>
          <div class="login-form__input-wrap">
            <span class="login-form__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" focusable="false">
                <path
                  d="M17 10V8a5 5 0 0 0-10 0v2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2Zm-8 0V8a3 3 0 0 1 6 0v2Z" />
              </svg>
            </span>
            <input [type]="showPassword ? 'text' : 'password'" formControlName="password" [placeholder]="'login.passwordPlaceholder' | translate" />
            <button
              type="button"
              class="login-form__toggle"
              (click)="togglePasswordVisibility()"
              [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
              @if (showPassword) {
                <svg viewBox="0 0 24 24" focusable="false">
                  <path
                    d="M3.53 2.47 2.47 3.53l3 3A11.77 11.77 0 0 0 1 12s4 7 11 7a10.8 10.8 0 0 0 4.51-1l3 3 1.06-1.06ZM12 17c-4.12 0-6.87-3.53-8.06-5A13.16 13.16 0 0 1 6.9 8l1.6 1.6A4.94 4.94 0 0 0 8 12a4 4 0 0 0 4 4 4.94 4.94 0 0 0 2.4-.5L16 17.1a8.61 8.61 0 0 1-4 .9Zm0-10a4.94 4.94 0 0 1 4.9 4.4l2.43 2.43A12.52 12.52 0 0 0 23 12s-4-7-11-7a10.71 10.71 0 0 0-3.83.69l1.79 1.79A4.94 4.94 0 0 1 12 7Zm-.42 2.06 4.36 4.36A2 2 0 0 0 12 10a1.94 1.94 0 0 0-.42.06Z" />
                </svg>
              } @else {
                <svg viewBox="0 0 24 24" focusable="false">
                  <path
                    d="M12 5C5 5 1 12 1 12s4 7 11 7 11-7 11-7-4-7-11-7Zm0 11a4 4 0 1 1 4-4 4 4 0 0 1-4 4Zm0-6.4A2.4 2.4 0 1 0 14.4 12 2.4 2.4 0 0 0 12 9.6Z" />
                </svg>
              }
            </button>
          </div>
          @if (hasError('password')) {
            <small class="login-form__error">{{ 'login.passwordRequired' | translate }}</small>
          }
        </label>

        <div class="login-form__meta">
          <label class="login-form__remember">
            <input type="checkbox" formControlName="remember" />
            <span>{{ 'login.remember' | translate }}</span>
          </label>
        </div>

        @if (errorMessage) {
          <p class="login-form__status login-form__status--error">{{ errorMessage }}</p>
        }

        <button type="submit" class="login-form__submit" [disabled]="isSubmitting">
          {{ isSubmitting ? ('login.submitting' | translate) : ('login.submit' | translate) }}
        </button>
      </form>
    </aside>

    <aside class="auth-shell__brand">
      <div class="auth-shell__brand-copy">
        <img class="auth-shell__logo" src="assets/logo-light.png" alt="Expert" />
        <p class="auth-shell__tagline">{{ 'login.brandTagline' | translate }}</p>
        <span class="auth-shell__department">{{ 'login.brandDepartment' | translate }}</span>
      </div>
    </aside>
  </div>

  <div class="hero__footer">
    <app-footer [compact]="true" />
  </div>
</section>
